import { render, staticRenderFns } from "./inventory-dialog.vue?vue&type=template&id=2de1108b&scoped=true&"
import script from "./inventory-dialog.vue?vue&type=script&lang=js&"
export * from "./inventory-dialog.vue?vue&type=script&lang=js&"
import style0 from "./inventory-dialog.vue?vue&type=style&index=0&id=2de1108b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1108b",
  null
  
)

export default component.exports